module.exports = __webpack_public_path__ + "img/local.fae6aa98.png";